import { UserProps } from '@/operator/utils/forms/BasicForm';
import { FirestoreUser, UpdateFirestoreUserInput } from 'generated/graphql';
import { isEqual } from 'lodash';

export const getUpdateUserInput = (
    originalUser: FirestoreUser,
    localUpdatedUser: UserProps,
): UpdateFirestoreUserInput => {
    let newUpdateUserInput: UpdateFirestoreUserInput = {};

    // Note: These are the possible user's properties can be updated
    const originalUserProps: UserProps = {
        firstName: originalUser.firstName,
        lastName: originalUser.lastName,
        displayName: originalUser.displayName,
        pronouns: originalUser.pronouns,
    };

    const localUserProps: UserProps = {
        firstName: localUpdatedUser.firstName,
        lastName: localUpdatedUser.lastName,
        displayName: localUpdatedUser.displayName,
        pronouns: localUpdatedUser.pronouns,
    };

    const userValuesFromDatabase = Object.values(originalUserProps);

    Object.entries(localUserProps).forEach(
        ([userPropertyName, userValue], index) => {
            if (!isEqual(userValue, userValuesFromDatabase[index])) {
                const newUserUpdates = {
                    [userPropertyName]: userValue,
                };
                newUpdateUserInput = Object.assign(
                    newUpdateUserInput,
                    newUserUpdates,
                );
            }
        },
    );

    return newUpdateUserInput;
};
